import { catchError } from 'rxjs/operators';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { SolicitacaoArquivos, TipoSolicitacaoArquivo, TipoSolicitacaoArquivos } from './../../model/solicitacao-arquivos.model';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";


@Injectable({
  providedIn:'root'
})
export class SolicitacaoArquivosService extends FgiBackEndService<SolicitacaoArquivos> {


  getNewEntity() {
      return null;
  }

  protected getResourceURL(): string {
      return 'front/solicitacao-arquivo';
  }

  public buscarPorFiltro(params?: any): Observable<Array<SolicitacaoArquivos>> {
    let options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}/`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<SolicitacaoArquivos>>;
  }

  public buscarConteudoSolicitacao(id: number): Observable<any>  {
    let options: any = blockUi();
    options.responseType = 'text';
    return this.http.get(`${this.BASE_URL}/conteudo/${id}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarTiposSolicitacaoArquivo(): Observable<Array<TipoSolicitacaoArquivos>> {
    let options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/tipos`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<TipoSolicitacaoArquivos>>;
  }

}
